import React,{useState} from 'react';
import {Button} from "@material-ui/core";
import styled from "styled-components";
import EditItem from './EditItem';

const Container=styled.div`
margin:15px;
box-shadow: rgb(154 160 185 / 75%) 0px 5px 10px, rgb(166 173 201 / 50%) 0px 15px 40px;
display:grid;
grid-template-columns:15% auto;
grid-template-rows:100%;`;

const Image=styled.img`
object-fit:cover;
width:100%;
height:100%;`;

const Title=styled.p`
text-align:start;
margin:5px;
font-weight:600;
font-size:20px;`;

const DescripcionUI=styled.p`
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2; 
-webkit-box-orient: vertical;`;

const Detalles=styled.div`
margin:10px;
display:block;`;


const DescripcionANDedit=styled.div`
display:grid;
grid-template-columns:auto min-content;
grid-template-rows:100%;`;

const Item = ({item}) => 
{
    const {id,data}=item;
    const {Nombre,Imagen,Descripcion,Precio,Estado}=data;
    const [openEdit, setopenEdit] = useState(false);

    const changeStatus=()=>
    {
        setopenEdit(!openEdit)
    }

    const labelText= Precio === 0 ? `${Nombre}` : `${Nombre} - $${Precio}`

    return <>
     <Container key={id} style={{backgroundColor:Estado ? "white" : "#cccccc"}} >
            <Image src={Imagen || "https://apibaumlanus.xyz/1648778165774-no-disponible.jpg"} />
            <Detalles className="item-detalles">
                <Title>{labelText}</Title>
                <DescripcionANDedit>
                    <DescripcionUI>{Descripcion}</DescripcionUI>
                    <Button style={{backgroundColor:"rgb(0, 136, 255)",color:"white",width:"min-content",height:"min-content",justifySelf:"end"}} variant="contained" onClick={changeStatus}>Editar</Button>
                </DescripcionANDedit>    
            </Detalles>
    </Container>
    <EditItem open={openEdit} close={changeStatus} item={item}/>
    </>
}

export default Item;
